export default {
  opcoesStatusHabilitacao: [
    {
      st_habilitacao: '-1',
      ds_habilitacao: 'Pendente Avaliação',
    },
    {
      st_habilitacao: '0',
      ds_habilitacao: 'Não Habilitada',
    },
    {
      st_habilitacao: '1',
      ds_habilitacao: 'Habilitada Desclassificada',
    },
    {
      st_habilitacao: '2',
      ds_habilitacao: 'Habilitada Classificada',
    },
    {
      st_habilitacao: '3',
      ds_habilitacao: 'Habilitada',
    },
  ],

  PENDENTE_AVALIACAO: '-1',
  NAO_HABILITADO: '0',
  HABILITADO: '1',

  INDICADO_CONSELHO_FILE_PATH: 'indicacao_conselho',
  headersIndicacao: [
    {
      text: 'CNPJ',
      value: 'cnpj_formatado',
    },
    {
      text: 'Nome do conselho',
      value: 'no_conselho',
    },
    {
      text: 'Indicado',
      value: 'no_indidcado',
    },
    {
      text: 'CPF',
      value: 'nu_cpf',
    },
    {
      text: 'UF',
      value: 'uf.no_uf',
    },
    {
      text: 'Região',
      value: 'uf.regiao.no_regiao',
    },
    {
      text: 'Habilitação',
      value: 'st_habilitacao',
    },
  ],
  headersConselho: [
    {
      text: 'CNPJ',
      value: 'cnpj_formatado',
    },
    {
      text: 'Nome do Conselho',
      value: 'no_conselho',
    },
    {
      text: 'UF',
      value: 'no_uf',
    },
    {
      text: 'Região',
      value: 'no_regiao',
    },
  ],

  descricaoArquivosIndicacao: {
    foto_indicado: 'Foto de rosto*',
    curriculo_indicado: 'Currículo*',
    curriculo_resumido_indicado: 'Currículo resumido para a candidatura*',
    portifolio_indicado: 'Portifólio*',
    cmpr_atuacao: 'Comprovação, por meio de portaria de designação ou termo de posse, de atuação em instâncias colegiadas nos últimos 10 anos, se houver',
    cpf_indicado: 'Cópia do documento de identificação (conforme item 2.8 deste edital) e CPF*',
    cmpres_indicado: 'Comprovante de residência com o nome do indicado ou declaração de residência (ANEXO 6)*',
    autorizacao_indicado: 'Declaração que autoriza a Secretaria Especial da Cultura do Ministério do Turismo a divulgar as imagens e informações contidas na inscrição e que responsabiliza o candidato pelos documentos e materiais apresentados (ANEXO 2 do edital)*',
    declaracao_indicado: 'Declaração do indicado de que possui disponibilidade para compor o Conselho Nacional de Política Cultural - CNPC, no triênio 2022/2025 (ANEXO 2 do edital)*',
    delico_indicado: 'Documento que comprove a deliberação do Conselho, presencial ou virtual, para indicação dos candidatos*',
    termo_indicacao: 'Termo de indicação de representante do Conselho de Cultura assinado pelo presidente do conselho (ANEXO 5)*',
  },

  RECURSO_INDICACAO_CONSELHO_FILE_PATH: 'recurso_indicacao_conselho',

  headersRecursoIndicacao: [
    {
      text: 'CNPJ',
      value: 'cnpj_formatado',
    },
    {
      text: 'Nome do conselho',
      value: 'no_conselho',
    },
    {
      text: 'UF',
      value: 'no_uf',
    },
    {
      text: 'Região',
      value: 'no_regiao',
    },
    {
      text: 'Data da Solicitação',
      value: 'dh_cadastro',
    },
    {
      text: 'Status',
      value: 'st_parecer',
    },
    {
      text: 'Ações',
      value: 'acoes',
      sorteable: false
    },
  ],
};
